import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';
import { LocalCacheService } from '../../services/localCache.service';

@Component({
  selector: 'app-add-note',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ToastModule],
  templateUrl: './add-note.component.html',
  styleUrl: './add-note.component.scss',
  providers: [MessageService],
})
export class AddNoteComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  modalInstance: any;
  noteForm: FormGroup = new FormGroup({});
  isButtonDisabled: boolean = false;
  stepInfo: string = '';
  isPASUser: boolean = false;
  noteList: any = [];
  isSuperAdminUser: boolean = false;
  isVisibleConfirm: boolean = false;
  noteDetails: any;
  constructor(
    public globalService: GlobalService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private localCacheService: LocalCacheService,
  ) {}

  @Input() isVisible = false;

  openModal(stepName: any) {
    this.stepInfo = stepName;
    this.isVisible = true;
    this.getNote();
  }

  closeModal() {
    this.isVisible = false;
    this.noteForm.reset();
  }
  

  ngOnInit(): void {
    var agentGuid =
      this.globalService.getQueryParamInfo('AgentGuid') ||
      this.localCacheService.getSessionStorage('agentGuid');
    var agentName =
      this.globalService.getQueryParamInfo('AgentName') ||
      this.localCacheService.getSessionStorage('agentName');
    if (agentName && agentGuid) {
      this.isPASUser = true;
      // this.getNote();
    }
    let d = this.localCacheService.getSessionStorage('d');
    this.isSuperAdminUser = d
      ? JSON.parse(this.localCacheService.getSessionStorage('d'))
      : false;
    this.noteForm = this.formBuilder.group({
      description: new FormControl('', [
        Validators.required,
      ]),
    });
  }

  getNote() {
    this.globalService
      .getNote()
      .subscribe({
        next: (response) => {
          if (response?.notes) {
            this.noteList = response.notes;
          }
        },
        error: (error) => {
          console.log('getNote error', error);
        },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  
  onAddNote() {
    this.isButtonDisabled = true;
    setTimeout(() => {
      this.isButtonDisabled = false;
    }, 1500);
    if (this.noteForm.invalid) {
      this.noteForm.markAllAsTouched();
      return;
    }
    this.globalService
      .addNote(this.stepInfo + ' ' + this.noteForm.value.description)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.showSuccessToast('Note added successfully!');
            this.noteForm.reset();
            this.getNote();
          }
        },
        error: (error) => {
          console.log('addNote error', error);
        },
    });
  }

  deleteNote(note: any) {
    this.isVisibleConfirm = true;
    this.noteDetails = note;
  }

  onDeleteNote() {
    this.isVisibleConfirm = false;
    this.globalService
      .deleteNote(this.noteDetails)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.showSuccessToast('Note deleted successfully!');
            this.getNote();
          }
        },
        error: (error) => {
          console.log('deleteNote error', error);
        },
    });
  }

  closeConfirmPopup() {
    this.isVisibleConfirm = false;
  }

  showSuccessToast(message: any) {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 3000,
    });
  }
}
